//
// "home" is the alias the app uses for the customer's own server wherever a partner
// id would otherwise sit: the back_home_jwt key, the piid-keyed maps in the qr, case
// and privilege stores, and the piid prop of screens that have no partner to name.
//
const piidIsHome = (piid) => ((!piid) || (piid === 'home'));

export default piidIsHome;
